import { Swiper } from 'swiper/swiper-bundle.esm.browser';
window.Swiper = Swiper;
$(document).ready(function() {
    const gamesSwiper = new Swiper('#swiper-testimonials-items', {
        slidesPerView: 1,
        // slidesPerGroup: 3,
        spaceBetween: 15,
        // freeMode: true,
        loop: true,
        // autoHeight: true,
        preloadImages: true,
        lazy: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
});
